import Core from "Core";
import { decorate, action } from "mobx";
import PageHandlers from "./PageHandlers";

export default class UIStore extends Core.Stores.UIStore {
  initializeHandlers() {
    this.view.addPageHandlers(PageHandlers);
  }
}

decorate(UIStore, {
  initializeHandlers: action
});



// WEBPACK FOOTER //
// ./src/Stores/UIStore/index.js